import React from "react";
import Modal from "react-bootstrap/Modal";
import Offcanvas from "react-bootstrap/Offcanvas";

// css
import * as styles from "./BookPack.module.css";

const BookPackTermsModal = props => {
  return (
    <>
      {props.windowSize && props.windowSize.width <= 768 ? (
        <Offcanvas
          show={props.showTermsCanvasModal}
          placement="bottom"
          style={{ height: "340px" }}
        >
          <Offcanvas.Body className={styles.bookpackForm_modal_termsBdy}>
            <div className="row">
              <div className="col-md-12">
                <h3 className="mb-3">Terms & Conditions</h3>
                <p>Twin Enrollment pack</p>
                <p>The payment for the enrollment pack is non-refundable.</p>
                <p>CGM patches (upto 6) are included in the pack</p>
              </div>
              <div className="col-md-12 text-center">
                <div className="mt-4">
                  <button
                    type="submit"
                    className={`${styles.bookpackForm_cta}`}
                    style={{ width: "100%" }}
                    onClick={props.onHideCanvasModal}
                  >
                    <div
                      className="bookBtn"
                      id="book-now"
                      style={{ margin: "auto" }}
                    >
                      <span className="bookBtn">Got it</span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      ) : (
        <Modal
          show={props.show}
          onHide={props.onHide}
          backdrop="static"
          centered={true}
          size="lg"
          className={styles.bookpackForm_termsModal}
        >
          <Modal.Body className={styles.bookpackForm_modal_termsBdy}>
            <div className="row">
              <div className="col-md-12">
                <h3 className="mb-3">Terms & Conditions</h3>
                <p>Twin Enrollment pack</p>
                <p>The payment for the enrollment pack is non-refundable.</p>
                <p>CGM patches (upto 6) are included in the pack</p>
              </div>
              <div className="col-md-12 text-center">
                <div className="mt-4">
                  <button
                    type="submit"
                    className={`${styles.bookpackForm_cta}`}
                    style={{ width: "100%" }}
                    onClick={props.onHide}
                  >
                    <div
                      className="bookBtn"
                      id="book-now"
                      style={{ margin: "auto" }}
                    >
                      <span className="bookBtn">Got it</span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default BookPackTermsModal;
